import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionLink } from 'src/app/model/result-grid/grid-action-link';

@Component({
  selector: 'action-link-cell-renderer',
  templateUrl: './action-link-cell-renderer.component.html',
  styleUrls: ['./action-link-cell-renderer.component.scss']
})
export class ActionLinkCellRenderer implements ICellRendererAngularComp {

  public params!: ICellRendererParams & {
    linkData: ActionLink
  };

  agInit(params: ICellRendererParams & {
    linkData: ActionLink
  }): void {
    this.params = params;
    this.setValueToDisplay();
  }
  refresh(params: ICellRendererParams & {
    linkData: ActionLink
  }): boolean {
    this.params = params;
    this.setValueToDisplay();
    return true;
  }
  public triggerAction(data: any) {
    this.params.linkData.actionCallback(data);
  }
  private setValueToDisplay() {
    if (this.params.linkData?.DisplayText !== undefined) {
      this.params.value = this.params.linkData?.DisplayText;
    }
  }
}
